// extracted by mini-css-extract-plugin
module.exports = {"centerBoth":"display_centerBoth__3iq3z","centerInlineBoth":"display_centerInlineBoth__BWz8-","centerVertical":"display_centerVertical__swFx-"};